import { render, staticRenderFns } from "./BaseFrontOfficeDialog.vue?vue&type=template&id=595e17b4&scoped=true"
import script from "./BaseFrontOfficeDialog.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeDialog.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeDialog.vue?vue&type=style&index=0&id=595e17b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595e17b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
